import SubHeader from 'components/SubHeader';
import { ROUTES } from 'shared/constants/routes';

const Breadcrumb = () => (
  <SubHeader
    title={ROUTES.ADMIN_SALES_REPORT.TITLE}
    links={[
      {
        title: 'Home',
        to: '/',
      },
    ]}
    currentPageTitle={ROUTES.ADMIN_SALES_REPORT.TITLE}
  />
);

export default Breadcrumb;
